module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XZSV3G/tc-custom/9781426842009.jpg?1728724861146",
      "alt": "This image is the cover for the book Sicilian Marriage, The O'Connells"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sicilian Marriage, The O'Connells\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Sicilian courtship:")]), _c('br'), _c('br'), _vm._v("Fast and furious—the sex was fantastic. But Briana O'Connell's explosive encounter with wealthy Sicilian Gianni Firelli was just for the moment, not a lifetime—wasn't it?"), _c('br'), _c('br'), _c('b', [_vm._v("The Sicilian marriage:")]), _vm._v("Formal and forever—Gianni has news for Briana: the tragedy that had brought them together in grief-fulled passion had also resulted in their both being named as joint guardians of a baby girl—for whose sake, Gianni insisted, they must marry!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra Marton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sandra Marton is a USA Todday Bestselling Author. A four-time finalist for the RITA, the coveted award given by Romance Writers of America, she's also won eight Romantic Times  Reviewers’ Choice Awards, the Holt Medallion, and Romantic Times’ Career Achievement Award. Sandra's heroes are powerful, sexy, take-charge men who think they have it all--until that one special woman comes along. Stand back, because together they're bound to set the world on fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0